import {getProfile as fetchProfiileAPI} from "../../services/profile";

export const getProfile = () => {
    return async (dispatch) => {
        dispatch({type: "FETCH_PROFILE_START"});
        try {
            const response = await fetchProfiileAPI();
            dispatch({
                type: "FETCH_PROFILE_SUCCESS",
                payload: response.data,
            });
        } catch (error) {
            console.error("Failed to fetch customer!", error);
        }
    };
}

